
import React from 'react';
import ResultModel from './ResultModel';
import Progressbar from './Progressbar';


class DifficultyLevel extends React.Component {


    state = {
        resultModels: []
    }

    componentDidMount = () => {

        let { app, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state
        let {resultModels}=this.state


        resultModels.push(new ResultModel(1, "سهل جدا", 0, 0, 0));
        resultModels.push(new ResultModel(2, "سهل", 0, 0, 0));
        resultModels.push(new ResultModel(3, "متوسط", 0, 0, 0));
        resultModels.push(new ResultModel(4, "صعب", 0, 0, 0));
        resultModels.push(new ResultModel(5, "صعب جدا", 0, 0, 0));

        for (let i = 0; i < quizViwerModel.activityArr.length; i++) {
            let activity = quizViwerModel.activityArr[i];

            for (let k = 0; k < resultModels.length; k++) {

                if (activity.difficulty == resultModels[k].id) {

                    resultModels[k].total++;
                    if (activity.answeredTrue) {
                        resultModels[k].right++;
                    } else {
                        resultModels[k].wrong++;
                    }
                }
            }
        }

        this.setState({ resultModels })

    }


    render = () => {

        let { resultModels } = this.state

        return (
            <>
                {
                    resultModels.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Progressbar resultModel={item} />
                            </React.Fragment>
                        )
                    })
                }
            </>
        )
    }

}


export default DifficultyLevel